<template>
  <div class="col-md-12 mx-auto">
    <v-row class="px-5 mt-5">
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.link" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="لینک"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="data.category" prepend-inner-icon="mdi-pencil" outlined clearable
                      clear-icon="mdi-close-circle-outline"
                      label="نام دسته"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete :items="qrTypes" item-text="text" item-value="value" dense v-model="data.type"
                        prepend-inner-icon="mdi-pencil"
                        outlined clearable clear-icon="mdi-close-circle-outline"
                        label="نوع"></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn :loading="loading" @click="sendPattern" class="submit-btn mr-auto float-left">
          <span class="fa fa-save ml-1" style="font-size: 14.5pt"></span>
          ثبت درخواست
        </v-btn>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import {RobotAxios} from "@/main";

export default {
  name: "customLink",
  props:{
    value:{
      default:{
        link:'',
        category:'',
        type:'',
      }
    }
  },
  data() {
    return {
      workType: [
        {title: 'لایف استایل ( سبک زندگی)', value: 'lifeStyle'},
        {title: 'موسیقی', value: 'music'},
        {title: 'املاک و خانه', value: 'real-estate'},
        {title: 'غذا (تستر و بلاگر غذا )', value: 'foodBlogger'},
        {title: 'اقتصادی و مالی', value: 'financial'},
        {title: 'سرمایه گذاری', value: 'investment'},
        {title: 'تکنولوژی', value: 'technology'},
        {title: 'طنز (واینر)', value: 'winer'},
        {title: 'بیوتی بلاگر', value: 'beautyBlogger'},
        {title: 'سفر و گردشگری', value: 'travelBlogger'},
        {title: 'ورزش و سلامت', value: 'sportBlogger'},
        {title: 'گیمینگ (استریمر)', value: 'gaming'},
        {title: 'مد و فشن', value: 'fashionBlogger'},
        {title: 'تناسب اندام (فیتنس بلاگر)', value: 'fitnessBlogger'},
        {title: 'ماشین', value: 'carBlogger'},
        {title: 'کتاب', value: 'bookBlogger'},
        {title: 'توسعه فردی', value: 'individualDevelopment'},
        {title: 'رشد', value: 'growth'},
        {title: 'راه‌های موفقیت', value: 'successWays'},
        {title: 'کوچ و کسب درآمد و بیزینسی', value: 'coach'},
        {title: 'بازاریابی (مارکتینگ)', value: 'marketing'},
        {title: 'آموزشی', value: 'education'},
      ],
      qrTypes: [
        {
          text: 'املاک',
          value: 'real-estate-business'
        },
        {
          text: 'نمایشگاه ماشین',
          value: 'car-business'
        },
        {
          text: 'شخصی',
          value: 'personal'
        },
        {
          text: 'صادرات',
          value: 'expert'
        },
        {
          text: 'فروشگاهی',
          value: 'marketplace'
        },
        {
          text: 'مشاغل',
          value: 'job-business'
        },
        {
          text: 'مشاور املاک',
          value: 'agent-real-estate-business'
        },
        {
          text: 'بنگاه ماشین',
          value: 'car-concierge-business'
        },
      ],
      loading:false

    }
  },
  methods: {
    restsFn() {
      this.value.link = '';
      this.value.category = '';
      this.value.type = '';
    },
    sendPattern() {
      this.loading = true;
      RobotAxios.post('/api/smart', {
        'payload': {
          link: this.value.link,
          title: this.value.category
        },
        'type': this.value.type
      }).then(() => {
        this.loading = false;
        this.$toast.success('درخواست شما با موفقیت ثبت شد.');
        this.reseData();
      }).catch((err) => {
        this.loading = false;
        this.$toast.error('خطا!');
      }).finally(() => {
        this.loading = false;
      })
    }

  },
  computed: {
    data: {
      set(value) {
        return this.$emit('input', value);
      },
      get() {
        return this?.value;
      }
    }
  },
  mounted() {
    this.restsFn();
  }
}
</script>

<style scoped>

</style>